<template>
    <div class="app-header-dropdown">
        <div class="app-header-dropdown__container">
            <div class="app-header-dropdown__items">
                <ui-link class="app-header-dropdown__anchor"
                    v-for="link in links"
                    v-bind:key="`header_link_${link}`"
                    v-bind:class="{ 'app-header-dropdown__anchor--active': $route.name === link }"
                    v-bind:to="{ name: link }">
                    <span class="app-header-dropdown__anchor-icon">
                        <icon-tokens v-if="link === 'market'" />
                        <icon-whales v-else-if="link === 'whales'" />
                        <icon-validators v-else-if="link === 'validators'" />
                        <icon-config v-else-if="link === 'config'" />
                        <icon-tools v-else-if="link === 'tools'" />
                    </span>
                    {{$t(`header.links.${link}`)}}
                </ui-link>
            </div>
        </div>
    </div>
</template>

<script>
import IconTokens from '@img/icons/filled/coins.svg?vue';
import IconWhales from '@img/icons/filled/trophy.svg?vue';
import IconValidators from '@img/icons/filled/nodes.svg?vue';
import IconConfig from '@img/icons/filled/sliders.svg?vue';
import IconTools from '@img/icons/filled/wrench.svg?vue';

export default {
    computed: {
        links() {
            return [
                'market',
                'validators',
                'whales',
                'config',
                'tools',
            ];
        },
    },

    components: {
        IconTokens,
        IconWhales,
        IconValidators,
        IconConfig,
        IconTools,
    },
};
</script>

<style lang="scss">
.app-header-dropdown {
    position: absolute;
    top: 44px;
    left: -4px;
    z-index: 1000;
    transform-origin: 24px top;

    // Invisible bridge over the gap between the link and the panel, so moving the
    // pointer down into the menu doesn't count as leaving the link:
    &::before {
        content: '';
        position: absolute;
        top: -12px;
        left: 0;
        right: 0;
        height: 12px;
    }

    &__container {
        min-width: 188px;
        background: var(--surface-elevated-background);
        border: 1px solid var(--card-border-color);
        box-shadow: 0 1px 2px var(--card-box-shadow-color), 0 16px 40px -12px var(--card-box-shadow-color);
        border-radius: 14px;
    }

    &__items {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 6px;
    }

    &__anchor {
        display: flex;
        align-items: center;
        gap: 10px;
        height: 38px;
        padding: 0 12px 0 10px;
        border-radius: 9px;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: -0.01em;
        color: var(--body-text-color);
        white-space: nowrap;
        text-decoration: none !important;
        transition: background-color .12s ease, color .12s ease;

        &:hover {
            background: var(--icon-button-hover-background);
        }

        &--active {
            background: var(--tab-thumb-background);
            .app-header-dropdown__anchor-icon {
                color: var(--blue-bright);
            }
        }
    }

    &__anchor-icon {
        display: inline-flex;
        width: 18px;
        height: 18px;
        color: var(--body-muted-text-color);
        transition: color .12s ease;
        svg {
            width: 18px;
            height: 18px;
        }
    }
}
</style>
